module.exports = __webpack_public_path__ + "img/1F975.02704f78.svg";